module.exports = new __parcel__URL__("1t.9862eb09.png").toString();